/******************************************************************************
 * AdminTools: super-admin "Tools" view. Groups operational/maintenance actions
 * (work order fixes, phone notifications, device backups) as tabs, each wiring
 * an existing core admin endpoint.
 *****************************************************************************/

/* Imports */
import { Typography } from "@material-tailwind/react";
import { ArchiveBoxIcon, BellAlertIcon, Squares2X2Icon, TruckIcon, UsersIcon } from "@heroicons/react/24/solid";
import { t } from "i18next";
/***/

/* Components */
import { TabsNav } from "../../../../components/tabs/TabsNav";
import AdminWorkorderToolsTab from "./tabs/workorders/AdminWorkorderToolsTab";
import AdminNotificationsToolsTab from "./tabs/notifications/AdminNotificationsToolsTab";
import AdminBackupsToolsTab from "./tabs/backups/AdminBackupsToolsTab";
import AdminMachineDedupTab from "./tabs/machine-dedup/AdminMachineDedupTab";
import AdminCustomerDedupTab from "./tabs/customer-dedup/AdminCustomerDedupTab";
/***/

/**
* AdminTools: super-admin tools view
*/
export default function AdminTools() {
  const tabs = [{
    label: t("admin:tools.tabs.workorders"),
    icon: TruckIcon,
    value: "workorders",
    Component: AdminWorkorderToolsTab
  }, {
    label: t("admin:tools.tabs.notifications"),
    icon: BellAlertIcon,
    value: "notifications",
    Component: AdminNotificationsToolsTab
  }, {
    label: t("admin:tools.tabs.backups"),
    icon: ArchiveBoxIcon,
    value: "backups",
    Component: AdminBackupsToolsTab
  }, {
    label: t("admin:tools.tabs.machineDedup"),
    icon: Squares2X2Icon,
    value: "machine-dedup",
    Component: AdminMachineDedupTab
  }, {
    label: t("admin:tools.tabs.customerDedup"),
    icon: UsersIcon,
    value: "customer-dedup",
    Component: AdminCustomerDedupTab
  }];

  return (
    <div className="views-padded">
      <div className="my-4">
        <div className="flex justify-between items-center actions">
          <Typography variant="h4">{t("admin:tools.title")}</Typography>
        </div>
      </div>

      <TabsNav<any> defaultTab="workorders" tabs={tabs} data={{}} />
    </div>
  );
}
/***/
